module.exports = __webpack_public_path__ + "static/img/feature_2.f57a273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/feature_2.png
// module id = G1vy
// module chunks = 0